import { showToast } from "../../showTost";
import VegIcon from "../../Icon/veg.svg";
import NonVegIcon from "../../Icon/nonveg.svg";
import { useContext } from "react";
import { MyContext } from "../../Context/MyProvider";
const SubAddonItemData = ({ data, addondata, currency, subAddonData, setSubAddonData, Required, setItemState, itemstate, selectaddonitem, isedit }) => {

    const { isVegtype } = useContext(MyContext);

    const isadded = itemstate.some(List => List.data.some(item => item.id === data.id));

    const handleSelectItem = (data) => {

        const FilterData = subAddonData.subaddondata.map((subitem) => {
            if (subitem.id === addondata.id) {
                if (subitem.addon_is_radio === "1") {
                    if (!subitem.additem) {
                        handleItemAdd(data);
                        return { ...subitem, additem: "1" };
                    } else {
                        if (!isadded) {
                            handleItemRemove(1, subitem);
                        }
                        setSubAddonData(data);
                    }
                } else {
                    if (subitem.additem !== Required) {
                        const isAdded = itemstate.some(List => List.data.some(item => item.id === data.id));

                        if (isAdded) {
                            handleItemRemove(2, subitem);
                        } else {
                            handleItemAdd(data);
                            const Count = subitem.additem ? Number(subitem.additem) + 1 : 1;
                            return { ...subitem, additem: String(Count) };
                        }
                    } else {

                        if (isadded) {
                            handleItemRemove(2, subitem);
                            const Count = subitem.additem ? Number(subitem.additem) - 1 : 0;
                            return { ...subitem, additem: String(Count) };
                        }
                        showToast({ title: `You can select a maximum of ${Required} ${addondata.title}`, id: "error" });
                        return subitem;
                    }
                }
            }
            return subitem;
        })

        setSubAddonData({ ...subAddonData, subaddondata: FilterData });
    }

    const handleItemAdd = (data) => {
        setItemState(prev => {
            const exists = (prev || []).some(item => item.title === selectaddonitem[0]?.title);
            if (exists) {
                return (prev || []).map(item => {
                    if (item.title === selectaddonitem[0]?.title) {
                        return { ...item, data: [...item.data, data] };
                    }
                    return item;
                });
            } else {
                return [...(prev || []), { title: selectaddonitem[0]?.title, price: selectaddonitem[0]?.price, data: [data] }];
            }
        });
    }

    const handleItemRemove = (index, item) => {

        if (index === 1) {
            const updateItems = itemstate.map(List => {
                const filteredData = List.data.filter(data =>
                    !item.addon_item_data.some(addon => addon.id === data.id)
                );
                return { ...List, data: [...filteredData, data] };
            });
            setItemState(updateItems);
        } else {
            // if (isedit === 0) {
            const updateItems = itemstate.map(List => {
                const filteredData = List.data.filter(item => item.id !== data.id);
                return { ...List, data: filteredData };
            });
            setItemState(updateItems);
            // } else {
            //     const updateItems = itemstate.map(List => {
            //         const filteredData = List.data.filter(item => item.title !== data.title);
            //         return { ...List, data: filteredData };
            //     });

            //     setItemState(updateItems);
            // }
        }
    }

    return <div onClick={() => handleSelectItem(data)} className="flex items-center justify-between pb-[10px] cursor-pointer">
        <div className="flex items-center gap-[5px]">
            {isVegtype === "1" ?
                <img src={VegIcon} className="w-[15px] mt-[2px]" alt="VegIcon" />
                : <img src={NonVegIcon} className="w-[15px] mt-[2px]" alt="NonVegIcon" />}
            <h1 className="text-[16px] text-[rgba(2,6,12,0.82)] whitespace-nowrap overflow-hidden overflow-ellipsis">{data.title}</h1>
        </div>
        <div className="text-[16px] text-gray-800 flex items-center gap-[10px]">
            <span>{addondata.addon_limit === "0" && "+"} {currency + data.price}</span>
            {addondata.addon_is_radio === "1"
                ? <div className={`${isadded ? "border-[#ff5200]" : "border-gray-500"} border-[2px] rounded-full p-[3px]`}>
                    <div className={`w-[8px] h-[8px] ${isadded ? "bg-[#ff5200]" : "bg-transparent"} rounded-full`}></div>
                </div>
                : <div className={`${isadded ? "bg-[#ff5200] border-[#ff5200]" : "border-gray-500"} border-[2px] rounded-[5px]`}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 17.75C8.999 17.75 8.99799 17.75 8.99699 17.75C8.79699 17.749 8.60599 17.669 8.46499 17.526L4.46499 13.464C4.17399 13.169 4.178 12.694 4.473 12.403C4.768 12.113 5.24399 12.116 5.53399 12.411L9.003 15.935L18.469 6.46902C18.762 6.17602 19.237 6.17602 19.53 6.46902C19.823 6.76202 19.823 7.23705 19.53 7.53005L9.53 17.5301C9.39 17.6711 9.199 17.75 9 17.75Z" fill="white" />
                    </svg>
                </div>}
        </div>
    </div>
}

export default SubAddonItemData;